/* Djurslottet - klickkansla: sokknappen + kollektionssidans paginering. INGA SPINNERS.

   Ligger som EXTERN asset: ett inline <script> i en header-group-sektion hamnar i DOM:en
   men KORS INTE (gruppen injiceras via innerHTML/section-hydration). Verifierat 2026-08-12.

   Pagineringen: temat ritar "nuvarande sida" som ett morkt block via
   .pagination__link--current::before (absolute, inset:2px, radius:6px, rgba(0,0,0,.81)).
   Vi doljer det (klassen .dj-pg-anim pa listan) och lagger in en identisk men FRI pill som
   kan glida. Vid klick: preventDefault -> pillen glider till den nya siffran -> forst
   darefter location.href. Utan fordrojningen hinner man aldrig se rorelsen.

   Har temat oandlig scroll i stallet for sidnummer finns ingen ul.pagination__list och
   pagineringsdelen gor da ingenting alls. */
(function () {
  var tag = document.querySelector('script[data-dj-slide]');
  var SLIDE = tag ? parseInt(tag.getAttribute('data-dj-slide'), 10) || 260 : 260;
  var REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function topbar() {
    var b = document.querySelector('.dj-topbar');
    if (!b) { b = document.createElement('div'); b.className = 'dj-topbar'; document.body.appendChild(b); }
    requestAnimationFrame(function () {
      b.style.width = '30%';
      requestAnimationFrame(function () { b.style.width = '72%'; });
    });
  }
  function clearLeaving() {
    var b = document.querySelector('.dj-topbar');
    if (b) b.remove();
    document.documentElement.classList.remove('dj-pg-leaving');
  }

  function place(pill, el, list) {
    var r = el.getBoundingClientRect(), lr = list.getBoundingClientRect();
    pill.style.width = (r.width - 4) + 'px';
    pill.style.height = (r.height - 4) + 'px';
    pill.style.transform = 'translate(' + (r.left - lr.left + 2) + 'px,' + (r.top - lr.top + 2) + 'px)';
  }

  var PILL = null;
  function setup() {
    var list = document.querySelector('ul.pagination__list');
    if (!list || list.querySelector('.dj-pg-pill')) return null;
    var cur = list.querySelector('.pagination__link--current');
    if (!cur) return null;
    var pill = document.createElement('span');
    pill.className = 'dj-pg-pill';
    list.appendChild(pill);
    list.classList.add('dj-pg-anim');
    place(pill, cur, list);
    window.addEventListener('resize', function () {
      var t = list.querySelector('.dj-pg-target') || list.querySelector('.pagination__link--current');
      if (t) place(pill, t, list);
    });
    return pill;
  }
  function ready() { try { PILL = setup(); } catch (e) {} }
  if (document.readyState !== 'loading') ready();
  else document.addEventListener('DOMContentLoaded', ready);

  function pageOf(href) {
    try { return new URL(href, location.href).searchParams.get('page') || '1'; } catch (e) { return null; }
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a.pagination__link') : null;
    if (!a) return;
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    if (a.target && a.target !== '_self') return;

    try { sessionStorage.setItem('djPgAnchor', '1'); } catch (err) {}

    var list = a.closest('ul.pagination__list');
    if (!list || !PILL || REDUCED) {
      if (!REDUCED) topbar();
      document.documentElement.classList.add('dj-pg-leaving');
      return;
    }

    /* for en pil: hitta samma sidnummer i listan sa markeringen kan glida dit */
    var target = a;
    if (a.classList.contains('pagination__link--arrow')) {
      var p = pageOf(a.getAttribute('href'));
      var match = null, links = list.querySelectorAll('.pagination__link--page');
      for (var i = 0; i < links.length; i++) {
        if (links[i].textContent.trim() === p) { match = links[i]; break; }
      }
      target = match || null;
    }

    e.preventDefault();
    document.documentElement.classList.add('dj-pg-leaving');
    topbar();

    if (target) {
      var cur = list.querySelector('.pagination__link--current');
      if (cur) cur.classList.add('dj-pg-left');
      target.classList.add('dj-pg-target');
      place(PILL, target, list);
    } else {
      PILL.style.opacity = '0';
    }

    var href = a.getAttribute('href');
    setTimeout(function () { window.location.href = href; }, SLIDE);
    /* sakerhetsnat om navigeringen av nagon anledning inte sker */
    setTimeout(function () {
      if (document.documentElement.classList.contains('dj-pg-leaving')) window.location.href = href;
    }, SLIDE + 1200);
  }, true);

  /* pa nasta sida: bladdra till rutnatets topp, inte sidans topp */
  function anchorToGrid() {
    try {
      var p = new URLSearchParams(location.search).get('page');
      if (!p || p === '1') return;
      if (sessionStorage.getItem('djPgAnchor') !== '1') return;
      sessionStorage.removeItem('djPgAnchor');
    } catch (err) { return; }
    var grid = document.querySelector('.product-grid');
    if (!grid) return;
    var header = document.querySelector('.header, header');
    var offset = header ? header.getBoundingClientRect().height + 12 : 12;
    var y = grid.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: REDUCED ? 'auto' : 'smooth' });
  }
  if (document.readyState !== 'loading') anchorToGrid();
  else document.addEventListener('DOMContentLoaded', anchorToGrid);

  window.addEventListener('pageshow', function (ev) { if (ev.persisted) clearLeaving(); });
})();
